(() => {
  const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const systemTheme = window.matchMedia('(prefers-color-scheme: dark)');
  let chosenTheme = null;
  try {
    const storedTheme = localStorage.getItem('bellum-theme');
    if (storedTheme === 'dark' || storedTheme === 'light') chosenTheme = storedTheme;
  } catch {}
  const applyTheme = theme => {
    document.documentElement.dataset.bTheme = theme;
    document.querySelectorAll('[data-b-theme-toggle]').forEach(button => {
      button.hidden = false;
      button.setAttribute('aria-pressed', String(theme === 'dark'));
      const label = button.querySelector('[data-b-theme-label]');
      const nextLabel = theme === 'dark' ? button.dataset.labelLight : button.dataset.labelDark;
      if (label && nextLabel) label.textContent = nextLabel;
    });
  };
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-b-theme-toggle]');
    if (!button) return;
    chosenTheme = document.documentElement.dataset.bTheme === 'dark' ? 'light' : 'dark';
    try { localStorage.setItem('bellum-theme', chosenTheme); } catch {}
    if (document.startViewTransition && !motion.matches) {
      document.startViewTransition(() => applyTheme(chosenTheme));
    } else applyTheme(chosenTheme);
  });
  systemTheme.addEventListener('change', () => {
    if (!chosenTheme) applyTheme(systemTheme.matches ? 'dark' : 'light');
  });
  window.addEventListener('storage', event => {
    if (event.key !== 'bellum-theme') return;
    chosenTheme = ['dark', 'light'].includes(event.newValue) ? event.newValue : null;
    applyTheme(chosenTheme || (systemTheme.matches ? 'dark' : 'light'));
  });
  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      if (!motion.matches) entry.target.classList.add('b-reveal-enter');
      revealObserver.unobserve(entry.target);
    });
  }, { threshold: 0.08 }) : null;
  function init(root = document) {
    applyTheme(chosenTheme || (systemTheme.matches ? 'dark' : 'light'));
    root.querySelectorAll('[data-b-card]').forEach(card => {
      if (card.dataset.bMotionReady) return;
      card.dataset.bMotionReady = 'true';
      if (revealObserver && !motion.matches && card.getBoundingClientRect().top >= window.innerHeight) revealObserver.observe(card);
    });
    root.querySelectorAll('[data-b-catalog]').forEach(catalog => {
      if (catalog.dataset.ready) return;
      catalog.dataset.ready = 'true';
      const search = catalog.querySelector('[data-b-search]');
      const gender = catalog.querySelector('[data-b-gender]');
      const cards = [...catalog.querySelectorAll('[data-b-card]')];
      const buttons = [...catalog.querySelectorAll('[data-b-filter]')];
      let category = '';
      const initial = new URLSearchParams(location.search).get('genero');
      if (['Mujer', 'Hombre', 'Unisex'].includes(initial)) gender.value = initial;
      const filter = () => {
        const query = normalize(search.value.trim());
        let count = 0;
        cards.forEach(card => {
          const show = (!category || card.dataset.category === category) && (!gender.value || card.dataset.gender === gender.value || card.dataset.gender === 'Unisex') && normalize(card.dataset.name).includes(query);
          card.hidden = !show;
          if (show) count++;
        });
        catalog.querySelector('[data-b-count]').textContent = `${count} ${count === 1 ? 'prenda' : 'prendas'}`;
        catalog.querySelector('[data-b-empty]').hidden = count > 0;
      };
      search.addEventListener('input', filter);
      gender.addEventListener('change', filter);
      buttons.forEach(button => button.addEventListener('click', () => {
        category = button.dataset.bFilter;
        buttons.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        filter();
      }));
      filter();
    });
    root.querySelectorAll('[data-b-product]').forEach(product => {
      if (product.dataset.ready) return;
      product.dataset.ready = 'true';
      const message = product.querySelector('[data-b-message]');
      const copy = product.querySelector('[data-b-copy]');
      const status = product.querySelector('[data-b-copy-status]');
      if (copy) copy.hidden = false;
      const update = () => {
        const selected = product.querySelector('input[type="radio"]:checked');
        const size = selected?.dataset.title || selected?.value || '';
        if (selected?.dataset.price) product.dataset.price = selected.dataset.price;
        const price = product.querySelector('[data-b-price]');
        if (price && selected?.dataset.price) price.textContent = selected.dataset.price;
        const comparePrice = product.querySelector('[data-b-compare-price]');
        if (comparePrice) {
          comparePrice.textContent = selected?.dataset.comparePrice || '';
          comparePrice.hidden = !selected?.dataset.comparePrice;
        }
        const saleBadge = product.querySelector('[data-b-sale-badge]');
        if (saleBadge) saleBadge.hidden = !selected?.dataset.comparePrice;
        const stock = product.querySelector('[data-b-stock]');
        if (stock && selected?.dataset.stock) stock.textContent = selected.dataset.stock;
        const purchaseButton = product.querySelector('[data-b-add-to-cart]');
        const quantity = product.querySelector('[data-b-quantity]');
        if (selected && 'available' in selected.dataset) {
          const available = selected.dataset.available === 'true';
          if (purchaseButton) {
            purchaseButton.disabled = !available;
            const label = available ? purchaseButton.dataset.labelAvailable : purchaseButton.dataset.labelSoldOut;
            if (label) purchaseButton.textContent = label;
          }
          if (quantity) {
            quantity.disabled = !available;
            const maximum = Number(selected.dataset.inventoryMax);
            if (Number.isFinite(maximum) && maximum > 0) {
              quantity.max = String(maximum);
              if (Number(quantity.value) > maximum) quantity.value = String(maximum);
            } else quantity.removeAttribute('max');
          }
        }
        const productUrl = new URL(location.pathname, location.origin);
        if (selected?.name === 'id') productUrl.searchParams.set('variant', selected.value);
        const subject = `Pedido BELLUM: ${product.dataset.title} — talla ${size}`;
        const body = `Hola BELLUM, quisiera coordinar mi pedido.\n\nPrenda: ${product.dataset.title}\nTalla: ${size}\nPrecio: ${product.dataset.price} PEN\nEnlace: ${productUrl.href}\n\nGracias.`;
        if (message) message.value = body;
        const whatsapp = product.querySelector('[data-b-whatsapp]');
        if (whatsapp) whatsapp.href = `https://wa.me/51916173535?text=${encodeURIComponent(body)}`;
        if (status) status.textContent = '';
        const consult = product.querySelector('[data-b-consult]');
        if (consult) consult.href = `mailto:${product.dataset.email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
      };
      copy?.addEventListener('click', async () => {
        if (!message) return;
        try {
          await navigator.clipboard.writeText(message.value);
          status.textContent = 'Mensaje copiado. Abre Instagram y pégalo en el chat con @bellum.pe.';
        } catch {
          message.focus();
          message.select();
          status.textContent = 'Mantén pulsado el texto o usa Ctrl+C para copiarlo y enviarlo por Instagram.';
        }
      });
      product.querySelectorAll('input[type="radio"]').forEach(input => input.addEventListener('change', update));
      const thumbnails = [...product.querySelectorAll('[data-b-thumb]')];
      const frames = [...product.querySelectorAll('[data-b-frame]')];
      const showFrame = button => {
        if (!button || button.getAttribute('aria-pressed') === 'true') return;
        frames.forEach(frame => {
          const active = frame.dataset.bFrame === button.dataset.bThumb;
          frame.classList.remove('b-frame-enter');
          frame.hidden = !active;
          if (active && !motion.matches) frame.classList.add('b-frame-enter');
        });
        thumbnails.forEach(thumb => thumb.setAttribute('aria-pressed', String(thumb === button)));
      };
      thumbnails.forEach((button, index) => {
        button.addEventListener('click', () => showFrame(button));
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % thumbnails.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + thumbnails.length) % thumbnails.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = thumbnails.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          showFrame(thumbnails[next]);
          thumbnails[next].focus();
        });
      });
      let touchStart = null;
      frames.forEach(frame => {
        frame.addEventListener('touchstart', event => {
          touchStart = event.touches.length === 1 ? { x: event.touches[0].clientX, y: event.touches[0].clientY } : null;
        }, { passive: true });
        frame.addEventListener('touchcancel', () => { touchStart = null; }, { passive: true });
        frame.addEventListener('touchend', event => {
          if (!touchStart || !event.changedTouches.length || thumbnails.length < 2) return;
          const deltaX = event.changedTouches[0].clientX - touchStart.x;
          const deltaY = event.changedTouches[0].clientY - touchStart.y;
          touchStart = null;
          if (Math.abs(deltaX) < 50 || Math.abs(deltaX) < Math.abs(deltaY) * 1.4) return;
          const current = thumbnails.findIndex(button => button.getAttribute('aria-pressed') === 'true');
          showFrame(thumbnails[(current + (deltaX < 0 ? 1 : -1) + thumbnails.length) % thumbnails.length]);
        }, { passive: true });
      });
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

